// extracted by mini-css-extract-plugin
module.exports = {"container":"SingleNote_container__3ImQR","noteContentLabel":"SingleNote_noteContentLabel__3KBGN","saveButton":"SingleNote_saveButton__2jkzG"};